class ctxTabController {
    constructor($element) {
        this.$element = $element;
    }

    $onInit() {
        this.name = this.ctxTabsCtrl.register(this.title, this.help);
    }

    isVisible() {
        return this.ctxTabsCtrl.active === this.name;
    }
}

const ctxTabsComponent = {
    controller: ctxTabController,
    controllerAs: 'ctxTabCtrl',
    template: '<div class="ctx-tab-default" ng-class="{\'ctx-tab-content\' : ctxTabCtrl.ctxTabsCtrl.animateTab}" grand-level="true" ng-if="ctxTabCtrl.isVisible()" ng-transclude></div>',
    transclude: true,
    replace: true,
    scope: {},
    bindings: {
        title: '@tabTitle',
        help: '@?helpInfo'
    },
    require: {
        ctxTabsCtrl: '^ctxTabs'
    }
};

ctxTabController.$inject = ['$element'];


module.exports = ctxTabsComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxTabs/ctxTab.component.js